import React, { memo } from 'react';
import PageHeader from '../components/layout/PageHeader';
import Gallery from '../components/ui/Gallery';
import Tabs from '../components/ui/Tabs';
import Button from '../components/ui/Button';
import { HomeIcon, UtensilsIcon, BedIcon, ShieldIcon, HeartIcon, UsersIcon, BookOpenIcon, MusicIcon, AwardIcon, CalendarIcon, ArrowRightIcon, ClockIcon, CheckIcon, MapPinIcon, ZapIcon, UserIcon, PaletteIcon, GlobeIcon, CpuIcon, MessageSquareIcon } from 'lucide-react';
const StudentLife = () => {
  const galleryImages = [{
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8M2i6Lt61u8AiKMZqhL6Xz/WhatsApp_Image_2025-10-24_at_10.01.22.jpg',
    alt: 'Cultural performance',
    caption: 'Students performing traditional cultural dance'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3DHAcubmTqmT13YpTTNQmr/WhatsApp_Image_2025-10-24_at_10.01.24.jpg',
    alt: 'Morning assembly',
    caption: 'Students at morning assembly'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mMF9fzVCb1rew9Z9Ba8RBR/WhatsApp_Image_2025-10-24_at_11.30.12.jpg',
    alt: 'School grounds',
    caption: 'Beautiful school grounds with pathways'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3iuYwPBfNvbAqWiL5UGdQD/WhatsApp_Image_2025-08-14_at_15.45.35_%283%29.jpg',
    alt: 'Students in classroom',
    caption: 'Students in their classroom'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tXB2gESgQyPW5hZWnwiFvU/WhatsApp_Image_2025-08-08_at_06.35.51_%281%29.jpg',
    alt: 'Student in uniform',
    caption: 'Student in front of the Chemistry Laboratory'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5gKYWryVTvwM3jPw4Bpnok/WhatsApp_Image_2025-10-24_at_10.01.16.jpg',
    alt: 'Chemistry laboratory',
    caption: 'Students conducting chemistry experiments'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ez9ThFy3DkQ6XwMpYtSRNQ/WhatsApp_Image_2025-10-24_at_10.01.16.jpg',
    alt: 'Students in laboratory',
    caption: 'Students engaged in practical science experiments'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rYxE1D1a3w1zMFiLJm2aU1/WhatsApp_Image_2025-10-24_at_10.01.17.jpg',
    alt: 'Chemistry lesson',
    caption: 'Interactive chemistry lesson in progress'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kMX4mMRKhHUYMbFhqjEMu9/WhatsApp_Image_2025-10-24_at_10.01.20_%281%29.jpg',
    alt: 'Biology lesson',
    caption: 'Biology teacher demonstrating with anatomical models'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/f2xgFc9rK22wZyJ7XvkYdc/WhatsApp_Image_2025-10-24_at_10.01.18.jpg',
    alt: 'Female cricket team',
    caption: 'IGS Girls Cricket Team with their coaches'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fqznuuu78HmKmW8bRuWFw1/WhatsApp_Image_2025-10-24_at_10.01.19.jpg',
    alt: 'Football training',
    caption: 'Students during football training session'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fhbXs7UNN6d2HJRiEebjre/WhatsApp_Image_2025-10-24_at_10.01.20.jpg',
    alt: 'Students in classroom',
    caption: 'Students attentively listening to their teacher during class'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/aeofuDDq4R4LzKTTb7kCTJ/WhatsApp_Image_2025-10-24_at_10.01.21.jpg',
    alt: 'Teacher with students in classroom',
    caption: 'Teacher engaging with students in a traditional classroom setting'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/26CHK6sEK66nfVUNdvbwf4/WhatsApp_Image_2025-10-24_at_10.01.20_%282%29.jpg',
    alt: 'Physics lesson with technology',
    caption: 'Teacher demonstrating wave mechanics using digital technology'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fBcdZe3j5kT56auYSAwRFV/WhatsApp_Image_2025-10-24_at_10.01.23_%281%29.jpg',
    alt: 'Mathematics teacher',
    caption: 'Teacher explaining advanced mathematics concepts on the whiteboard'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3GFAKQjjuFe5vR4bv8XoiJ/WhatsApp_Image_2025-10-24_at_10.01.21_%281%29.jpg',
    alt: 'Computer lab session',
    caption: 'Students learning in the modern computer laboratory'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vKv5s2R4J3htwPZBqsE5mu/WhatsApp_Image_2025-10-24_at_10.01.23.jpg',
    alt: 'Teacher teaching students in classroom',
    caption: 'Female teacher in traditional attire engaging students in an active learning session'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8v7HegjxEmi2KSxNec1Zxz/WhatsApp_Image_2025-10-24_at_10.01.25.jpg',
    alt: 'Sports team on field',
    caption: 'School sports team ready for competition on the field'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hWx5tyEVbwQVrxum4dtVj3/WhatsApp_Image_2025-10-24_at_13.20.17_%281%29.jpg',
    alt: 'Students in science laboratory',
    caption: 'Students conducting experiments in the modern science laboratory'
  }];
  const testimonials = [{
    name: 'Oluwaseun Adebayo',
    role: 'Current Student, SS3',
    quote: "The boarding experience at IGS has taught me independence and discipline. The facilities are excellent, and the house parents are caring and supportive. I've made lifelong friends here.",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3DHAcubmTqmT13YpTTNQmr/WhatsApp_Image_2025-10-24_at_10.01.24.jpg'
  }, {
    name: 'Chioma Nwosu',
    role: 'Current Student, SS2',
    quote: "I love the balance between academics and extracurricular activities at IGS. The sports facilities are amazing, and I've been able to develop my talent in basketball while maintaining good grades.",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tXB2gESgQyPW5hZWnwiFvU/WhatsApp_Image_2025-08-08_at_06.35.51_%281%29.jpg'
  }, {
    name: 'Mrs. Adebola Johnson',
    role: 'Parent',
    quote: "The transformation in my son since joining IGS has been remarkable. The school's holistic approach to education, combining academic rigor with character development, is exactly what we were looking for.",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3iuYwPBfNvbAqWiL5UGdQD/WhatsApp_Image_2025-08-14_at_15.45.35_%283%29.jpg'
  }];
  const upcomingEvents = [{
    name: 'Inter-House Sports Competition',
    date: 'November 15, 2024',
    time: '9:00 AM',
    location: 'School Sports Ground',
    description: 'Annual sports competition featuring track and field events, team sports, and individual competitions.'
  }, {
    name: 'Cultural Day Celebration',
    date: 'December 10, 2024',
    time: '10:00 AM',
    location: 'School Hall',
    description: "A colorful celebration of Nigeria's diverse cultures featuring traditional dances, attire, and cuisine."
  }, {
    name: 'Christmas Carol Service',
    date: 'December 18, 2024',
    time: '4:00 PM',
    location: 'School Chapel',
    description: 'Annual carol service featuring performances by the school choir and drama group.'
  }, {
    name: 'Science & Technology Fair',
    date: 'February 20, 2025',
    time: '9:00 AM',
    location: 'School Hall',
    description: 'Exhibition of student projects in science, technology, engineering, and mathematics.'
  }];
  return <div className="min-h-screen bg-white" data-id="element-5253">
      <PageHeader title="Student Life at IGS" description="Experience the vibrant and balanced life of students at Isonyin Grammar School, where education extends beyond the classroom." backgroundImage="https://uploadthingy.s3.us-west-1.amazonaws.com/jdfoyTCXLviMyjmi5MDX1X/WhatsApp_Image_2025-10-24_at_11.30.13.jpg" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'Student Life',
      path: '/student-life'
    }]} data-id="element-5254" />
      <div className="container mx-auto px-4 py-12" data-id="element-5255">
        {/* Introduction Section */}
        <section className="mb-16" data-id="element-5256">
          <div className="text-center mb-10" data-id="element-5257">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-5258">
              Life at Isonyin Grammar School
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-5259"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-5260">
              At IGS, we provide a nurturing environment where students can grow
              academically, socially, and morally. Our balanced approach ensures
              that students enjoy a rich and fulfilling school experience.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-5261">
            <div data-id="element-5262">
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-5263">
                Student life at Isonyin Grammar School is vibrant and dynamic,
                offering a perfect balance of academic rigor and extracurricular
                activities. We believe that education extends beyond the
                classroom, and our comprehensive approach focuses on developing
                the whole student.
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-5264">
                Whether as day students or boarders, our students benefit from a
                structured environment that promotes discipline, responsibility,
                and independence. The strong sense of community and camaraderie
                among students creates lifelong friendships and a supportive
                network.
              </p>
              <p className="text-gray-700 leading-relaxed" data-id="element-5265">
                From sports competitions to cultural celebrations, from
                community service to leadership opportunities, IGS offers
                numerous avenues for students to discover and develop their
                talents and interests.
              </p>
            </div>
            <Gallery images={galleryImages} columns={2} gap="medium" rounded={true} className="overflow-hidden rounded-lg shadow-md" data-id="element-5266" />
          </div>
        </section>
        {/* Boarding Life Section */}
        <section className="mb-16" id="boarding" data-id="element-5267">
          <div className="text-center mb-10" data-id="element-5268">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-5269">
              Boarding Life
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-5270"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-5271">
              Our boarding facilities provide a home away from home for
              students, fostering independence, discipline, and lifelong
              friendships.
            </p>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-5272">
            <div className="lg:col-span-2" data-id="element-5273">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4jLMnmKXSAWwavqGR8zdhM/WhatsApp_Image_2025-10-24_at_11.30.13_%281%29.jpg" alt="Boarding facilities" className="w-full h-96 object-cover rounded-lg shadow-md mb-6" data-id="element-5274" />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-5275">
                <div className="bg-blue-50 p-6 rounded-lg" data-id="element-5276">
                  <div className="flex items-center mb-4" data-id="element-5277">
                    <HomeIcon className="h-6 w-6 text-blue-700 mr-3" data-id="element-5278" />
                    <h3 className="text-xl font-bold text-blue-900" data-id="element-5279">
                      Dormitories
                    </h3>
                  </div>
                  <p className="text-gray-700" data-id="element-5280">
                    Our dormitories are designed to provide comfort, privacy,
                    and a conducive environment for rest and study. Each
                    dormitory houses students of the same gender and similar age
                    groups, supervised by experienced house parents.
                  </p>
                </div>
                <div className="bg-blue-50 p-6 rounded-lg" data-id="element-5281">
                  <div className="flex items-center mb-4" data-id="element-5282">
                    <UtensilsIcon className="h-6 w-6 text-blue-700 mr-3" data-id="element-5283" />
                    <h3 className="text-xl font-bold text-blue-900" data-id="element-5284">Dining</h3>
                  </div>
                  <p className="text-gray-700" data-id="element-5285">
                    Our dining hall serves nutritious and balanced meals three
                    times daily, with provisions for special dietary needs. The
                    menu is varied and includes local and continental dishes
                    prepared by trained catering staff.
                  </p>
                </div>
                <div className="bg-blue-50 p-6 rounded-lg" data-id="element-5286">
                  <div className="flex items-center mb-4" data-id="element-5287">
                    <ShieldIcon className="h-6 w-6 text-blue-700 mr-3" data-id="element-5288" />
                    <h3 className="text-xl font-bold text-blue-900" data-id="element-5289">
                      Safety & Security
                    </h3>
                  </div>
                  <p className="text-gray-700" data-id="element-5290">
                    The safety and security of our students is paramount. Our
                    campus is secured with perimeter fencing, 24-hour security
                    personnel, and CCTV surveillance. Regular safety drills are
                    conducted.
                  </p>
                </div>
                <div className="bg-blue-50 p-6 rounded-lg" data-id="element-5291">
                  <div className="flex items-center mb-4" data-id="element-5292">
                    <HeartIcon className="h-6 w-6 text-blue-700 mr-3" data-id="element-5293" />
                    <h3 className="text-xl font-bold text-blue-900" data-id="element-5294">
                      Health Services
                    </h3>
                  </div>
                  <p className="text-gray-700" data-id="element-5295">
                    Our on-campus clinic is staffed by qualified healthcare
                    professionals who provide routine and emergency medical
                    care. For specialized care, we have partnerships with nearby
                    hospitals.
                  </p>
                </div>
              </div>
              <h3 className="text-xl font-bold text-blue-900 mb-4" data-id="element-5296">
                Daily Routine for Boarders
              </h3>
              <div className="overflow-x-auto" data-id="element-5297">
                <table className="min-w-full bg-white border border-gray-200 rounded-lg" data-id="element-5298">
                  <thead data-id="element-5299">
                    <tr className="bg-blue-900 text-white" data-id="element-5300">
                      <th className="py-2 px-4 text-left" data-id="element-5301">Time</th>
                      <th className="py-2 px-4 text-left" data-id="element-5302">Activity</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200" data-id="element-5303">
                    <tr className="bg-white hover:bg-gray-50" data-id="element-5304">
                      <td className="py-2 px-4 font-medium" data-id="element-5305">5:30 AM</td>
                      <td className="py-2 px-4" data-id="element-5306">Wake up</td>
                    </tr>
                    <tr className="bg-gray-50 hover:bg-gray-100" data-id="element-5307">
                      <td className="py-2 px-4 font-medium" data-id="element-5308">
                        5:30 AM - 6:30 AM
                      </td>
                      <td className="py-2 px-4" data-id="element-5309">
                        Morning preparation (bath, chores)
                      </td>
                    </tr>
                    <tr className="bg-white hover:bg-gray-50" data-id="element-5310">
                      <td className="py-2 px-4 font-medium" data-id="element-5311">
                        6:30 AM - 7:15 AM
                      </td>
                      <td className="py-2 px-4" data-id="element-5312">Breakfast</td>
                    </tr>
                    <tr className="bg-gray-50 hover:bg-gray-100" data-id="element-5313">
                      <td className="py-2 px-4 font-medium" data-id="element-5314">
                        7:45 AM - 3:30 PM
                      </td>
                      <td className="py-2 px-4" data-id="element-5315">School hours</td>
                    </tr>
                    <tr className="bg-white hover:bg-gray-50" data-id="element-5316">
                      <td className="py-2 px-4 font-medium" data-id="element-5317">
                        3:30 PM - 4:30 PM
                      </td>
                      <td className="py-2 px-4" data-id="element-5318">Extracurricular activities</td>
                    </tr>
                    <tr className="bg-gray-50 hover:bg-gray-100" data-id="element-5319">
                      <td className="py-2 px-4 font-medium" data-id="element-5320">
                        4:30 PM - 5:30 PM
                      </td>
                      <td className="py-2 px-4" data-id="element-5321">Free time / Rest</td>
                    </tr>
                    <tr className="bg-white hover:bg-gray-50" data-id="element-5322">
                      <td className="py-2 px-4 font-medium" data-id="element-5323">
                        5:30 PM - 6:30 PM
                      </td>
                      <td className="py-2 px-4" data-id="element-5324">Dinner</td>
                    </tr>
                    <tr className="bg-gray-50 hover:bg-gray-100" data-id="element-5325">
                      <td className="py-2 px-4 font-medium" data-id="element-5326">
                        7:00 PM - 9:00 PM
                      </td>
                      <td className="py-2 px-4" data-id="element-5327">
                        Evening prep (supervised study)
                      </td>
                    </tr>
                    <tr className="bg-white hover:bg-gray-50" data-id="element-5328">
                      <td className="py-2 px-4 font-medium" data-id="element-5329">
                        9:00 PM - 9:30 PM
                      </td>
                      <td className="py-2 px-4" data-id="element-5330">Evening devotion</td>
                    </tr>
                    <tr className="bg-gray-50 hover:bg-gray-100" data-id="element-5331">
                      <td className="py-2 px-4 font-medium" data-id="element-5332">
                        9:30 PM / 10:00 PM
                      </td>
                      <td className="py-2 px-4" data-id="element-5333">Lights out (JSS / SS)</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div data-id="element-5334">
              <div className="bg-blue-900 text-white p-6 rounded-lg mb-6" data-id="element-5335">
                <div className="flex items-center mb-4" data-id="element-5336">
                  <BedIcon className="h-6 w-6 text-yellow-400 mr-3" data-id="element-5337" />
                  <h3 className="text-xl font-bold" data-id="element-5338">Boarding Facilities</h3>
                </div>
                <ul className="space-y-3" data-id="element-5339">
                  <li className="flex items-start" data-id="element-5340">
                    <div className="flex-shrink-0 h-5 w-5 text-yellow-400 mr-2" data-id="element-5341">
                      ✓
                    </div>
                    <p data-id="element-5342">Separate dormitories for boys and girls</p>
                  </li>
                  <li className="flex items-start" data-id="element-5343">
                    <div className="flex-shrink-0 h-5 w-5 text-yellow-400 mr-2" data-id="element-5344">
                      ✓
                    </div>
                    <p data-id="element-5345">Comfortable bunk beds with storage space</p>
                  </li>
                  <li className="flex items-start" data-id="element-5346">
                    <div className="flex-shrink-0 h-5 w-5 text-yellow-400 mr-2" data-id="element-5347">
                      ✓
                    </div>
                    <p data-id="element-5348">Modern bathroom facilities</p>
                  </li>
                  <li className="flex items-start" data-id="element-5349">
                    <div className="flex-shrink-0 h-5 w-5 text-yellow-400 mr-2" data-id="element-5350">
                      ✓
                    </div>
                    <p data-id="element-5351">Common rooms with recreational facilities</p>
                  </li>
                  <li className="flex items-start" data-id="element-5352">
                    <div className="flex-shrink-0 h-5 w-5 text-yellow-400 mr-2" data-id="element-5353">
                      ✓
                    </div>
                    <p data-id="element-5354">Study areas with adequate lighting</p>
                  </li>
                  <li className="flex items-start" data-id="element-5355">
                    <div className="flex-shrink-0 h-5 w-5 text-yellow-400 mr-2" data-id="element-5356">
                      ✓
                    </div>
                    <p data-id="element-5357">Laundry services</p>
                  </li>
                  <li className="flex items-start" data-id="element-5358">
                    <div className="flex-shrink-0 h-5 w-5 text-yellow-400 mr-2" data-id="element-5359">
                      ✓
                    </div>
                    <p data-id="element-5360">24-hour security and supervision</p>
                  </li>
                </ul>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-5361">
                <div className="flex items-center mb-4" data-id="element-5362">
                  <UsersIcon className="h-6 w-6 text-blue-700 mr-3" data-id="element-5363" />
                  <h3 className="text-xl font-bold text-blue-900" data-id="element-5364">
                    House System
                  </h3>
                </div>
                <p className="text-gray-700 mb-4" data-id="element-5365">
                  Boarders are organized into houses, each named after notable
                  Nigerian educational pioneers:
                </p>
                <ul className="space-y-3 text-gray-700" data-id="element-5366">
                  <li className="flex items-start" data-id="element-5367">
                    <div className="w-4 h-4 rounded-full bg-red-500 mt-1 mr-2" data-id="element-5368"></div>
                    <p data-id="element-5369">
                      <strong data-id="element-5370">Ransome-Kuti House</strong> (Red)
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-5371">
                    <div className="w-4 h-4 rounded-full bg-blue-500 mt-1 mr-2" data-id="element-5372"></div>
                    <p data-id="element-5373">
                      <strong data-id="element-5374">Awolowo House</strong> (Blue)
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-5375">
                    <div className="w-4 h-4 rounded-full bg-green-500 mt-1 mr-2" data-id="element-5376"></div>
                    <p data-id="element-5377">
                      <strong data-id="element-5378">Azikiwe House</strong> (Green)
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-5379">
                    <div className="w-4 h-4 rounded-full bg-yellow-500 mt-1 mr-2" data-id="element-5380"></div>
                    <p data-id="element-5381">
                      <strong data-id="element-5382">Bello House</strong> (Yellow)
                    </p>
                  </li>
                </ul>
                <p className="mt-4 text-gray-700" data-id="element-5383">
                  Each house competes in academic, sports, and cultural
                  activities throughout the year, fostering a sense of
                  belonging, teamwork, and healthy competition.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Arts & Culture Section */}
        <section className="mb-16" id="arts" data-id="element-5384">
          <div className="text-center mb-10" data-id="element-5385">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-5386">
              Arts & Culture
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-5387"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-5388">
              We celebrate creativity and cultural expression through our arts
              programs, traditional performances, and cultural events throughout
              the year.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-12" data-id="element-5389">
            <div className="relative" data-id="element-5390">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8M2i6Lt61u8AiKMZqhL6Xz/WhatsApp_Image_2025-10-24_at_10.01.22.jpg" alt="Cultural performance" className="w-full h-96 object-cover rounded-lg shadow-md" data-id="element-5391" />
              <div className="absolute bottom-4 right-4 bg-blue-900 text-white p-3 rounded-lg shadow-lg" data-id="element-5392">
                <p className="font-bold" data-id="element-5393">Cultural Group</p>
                <p className="text-sm" data-id="element-5394">Traditional Dance Performance</p>
              </div>
            </div>
            <div data-id="element-5395">
              <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-5396">
                Cultural Heritage
              </h3>
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-5397">
                Our cultural groups showcase the rich heritage of Nigeria
                through traditional dances, music, and performances. Students
                learn about their cultural roots while developing confidence and
                stage presence.
              </p>
              <ul className="space-y-3 mb-6" data-id="element-5398">
                <li className="flex items-start" data-id="element-5399">
                  <div className="flex-shrink-0 h-6 w-6 rounded-full bg-blue-100 flex items-center justify-center mr-2" data-id="element-5400">
                    <CheckIcon className="h-4 w-4 text-blue-700" data-id="element-5401" />
                  </div>
                  <span className="text-gray-700" data-id="element-5402">
                    Traditional dance and music groups
                  </span>
                </li>
                <li className="flex items-start" data-id="element-5403">
                  <div className="flex-shrink-0 h-6 w-6 rounded-full bg-blue-100 flex items-center justify-center mr-2" data-id="element-5404">
                    <CheckIcon className="h-4 w-4 text-blue-700" data-id="element-5405" />
                  </div>
                  <span className="text-gray-700" data-id="element-5406">
                    Cultural festivals and celebrations
                  </span>
                </li>
                <li className="flex items-start" data-id="element-5407">
                  <div className="flex-shrink-0 h-6 w-6 rounded-full bg-blue-100 flex items-center justify-center mr-2" data-id="element-5408">
                    <CheckIcon className="h-4 w-4 text-blue-700" data-id="element-5409" />
                  </div>
                  <span className="text-gray-700" data-id="element-5410">
                    Inter-school cultural competitions
                  </span>
                </li>
                <li className="flex items-start" data-id="element-5411">
                  <div className="flex-shrink-0 h-6 w-6 rounded-full bg-blue-100 flex items-center justify-center mr-2" data-id="element-5412">
                    <CheckIcon className="h-4 w-4 text-blue-700" data-id="element-5413" />
                  </div>
                  <span className="text-gray-700" data-id="element-5414">
                    Drama and theater productions
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </section>
        {/* Daily Life Section */}
        <section className="mb-16" data-id="element-5415">
          <div className="text-center mb-10" data-id="element-5416">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-5417">
              Daily Life at IGS
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-5418"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-5419">
              A typical day at Isonyin Grammar School is structured to balance
              academics, character development, and personal growth.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-5420">
            <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-5421">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3DHAcubmTqmT13YpTTNQmr/WhatsApp_Image_2025-10-24_at_10.01.24.jpg" alt="Morning assembly" className="w-full h-64 object-cover" data-id="element-5422" />
              <div className="p-6" data-id="element-5423">
                <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-5424">
                  Morning Assembly
                </h3>
                <p className="text-gray-700" data-id="element-5425">
                  Each day begins with morning assembly where students gather
                  for prayers, announcements, and motivational talks. This helps
                  instill discipline and unity among students.
                </p>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-5426">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vKv5s2R4J3htwPZBqsE5mu/WhatsApp_Image_2025-10-24_at_10.01.23.jpg" alt="Teacher teaching in classroom" className="w-full h-64 object-cover" data-id="element-5427" />
              <div className="p-6" data-id="element-5428">
                <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-5429">
                  Interactive Classroom Learning
                </h3>
                <p className="text-gray-700" data-id="element-5430">
                  Our experienced teachers, many in traditional attire, create
                  engaging learning environments where students actively
                  participate and develop critical thinking skills.
                </p>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-5431">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fhbXs7UNN6d2HJRiEebjre/WhatsApp_Image_2025-10-24_at_10.01.20.jpg" alt="Students in classroom" className="w-full h-64 object-cover" data-id="element-5432" />
              <div className="p-6" data-id="element-5433">
                <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-5434">
                  Engaged Learning Environment
                </h3>
                <p className="text-gray-700" data-id="element-5435">
                  Students are actively engaged in their lessons, with teachers
                  using various methods to ensure understanding and
                  participation from all students.
                </p>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-5436">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hWx5tyEVbwQVrxum4dtVj3/WhatsApp_Image_2025-10-24_at_13.20.17_%281%29.jpg" alt="Science laboratory practical" className="w-full h-64 object-cover" data-id="element-5437" />
              <div className="p-6" data-id="element-5438">
                <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-5439">
                  Hands-On Science Education
                </h3>
                <p className="text-gray-700" data-id="element-5440">
                  Students engage in practical science experiments in our
                  well-equipped laboratories, developing critical scientific
                  inquiry and research skills.
                </p>
              </div>
            </div>
          </div>
          {/* Computer Lab Section */}
          <div className="bg-gray-50 p-8 rounded-lg" data-id="element-5441">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-5442">
              <div data-id="element-5443">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3GFAKQjjuFe5vR4bv8XoiJ/WhatsApp_Image_2025-10-24_at_10.01.21_%281%29.jpg" alt="Students in computer laboratory" className="w-full rounded-lg shadow-lg" data-id="element-5444" />
              </div>
              <div data-id="element-5445">
                <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-5446">
                  Digital Learning Environment
                </h3>
                <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-5447">
                  Our computer laboratory provides students with hands-on
                  experience in digital literacy, programming, and modern
                  technology applications. Under the guidance of experienced
                  instructors, students develop essential 21st-century skills.
                </p>
                <p className="text-gray-700 leading-relaxed" data-id="element-5448">
                  The lab is equipped with modern computers and software,
                  allowing students to work on projects, research, and develop
                  their technology skills in a supportive environment.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Sports & Recreation Section */}
        <section className="mb-16" id="sports" data-id="element-5449">
          <div className="text-center mb-10" data-id="element-5450">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-5451">
              Sports & Recreation
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-5452"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-5453">
              Physical education and sports are integral parts of our
              curriculum, promoting physical fitness, teamwork, and character
              development.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-12" data-id="element-5454">
            <div className="order-2 md:order-1" data-id="element-5455">
              <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-5456">
                Sporting Excellence
              </h3>
              <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-5457">
                At IGS, we believe in the importance of physical education in
                developing well-rounded individuals. Our comprehensive sports
                program caters to various interests and abilities, allowing
                students to discover and develop their athletic talents.
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-5458">
                Regular physical education classes are complemented by
                competitive sports, with opportunities to participate in
                inter-house, inter-school, state, and national competitions. Our
                coaches are experienced professionals dedicated to nurturing
                talent and instilling the values of sportsmanship, discipline,
                and teamwork.
              </p>
              <div className="grid grid-cols-2 gap-4" data-id="element-5459">
                <div className="bg-blue-50 p-4 rounded-lg" data-id="element-5460">
                  <div className="flex items-center mb-2" data-id="element-5461">
                    <UsersIcon className="h-5 w-5 text-blue-700 mr-2" data-id="element-5462" />
                    <h4 className="font-bold text-blue-900" data-id="element-5463">Team Sports</h4>
                  </div>
                  <ul className="text-gray-700 text-sm space-y-1" data-id="element-5464">
                    <li data-id="element-5465">• Football</li>
                    <li data-id="element-5466">• Basketball</li>
                    <li data-id="element-5467">• Volleyball</li>
                    <li data-id="element-5468">• Cricket</li>
                  </ul>
                </div>
                <div className="bg-blue-50 p-4 rounded-lg" data-id="element-5469">
                  <div className="flex items-center mb-2" data-id="element-5470">
                    <ZapIcon className="h-5 w-5 text-blue-700 mr-2" data-id="element-5471" />
                    <h4 className="font-bold text-blue-900" data-id="element-5472">Track & Field</h4>
                  </div>
                  <ul className="text-gray-700 text-sm space-y-1" data-id="element-5473">
                    <li data-id="element-5474">• Sprints</li>
                    <li data-id="element-5475">• Long-distance running</li>
                    <li data-id="element-5476">• Jumps</li>
                    <li data-id="element-5477">• Throws</li>
                  </ul>
                </div>
                <div className="bg-blue-50 p-4 rounded-lg" data-id="element-5478">
                  <div className="flex items-center mb-2" data-id="element-5479">
                    <UserIcon className="h-5 w-5 text-blue-700 mr-2" data-id="element-5480" />
                    <h4 className="font-bold text-blue-900" data-id="element-5481">
                      Individual Sports
                    </h4>
                  </div>
                  <ul className="text-gray-700 text-sm space-y-1" data-id="element-5482">
                    <li data-id="element-5483">• Table Tennis</li>
                    <li data-id="element-5484">• Badminton</li>
                    <li data-id="element-5485">• Chess</li>
                    <li data-id="element-5486">• Swimming</li>
                  </ul>
                </div>
                <div className="bg-blue-50 p-4 rounded-lg" data-id="element-5487">
                  <div className="flex items-center mb-2" data-id="element-5488">
                    <MusicIcon className="h-5 w-5 text-blue-700 mr-2" data-id="element-5489" />
                    <h4 className="font-bold text-blue-900" data-id="element-5490">Recreational</h4>
                  </div>
                  <ul className="text-gray-700 text-sm space-y-1" data-id="element-5491">
                    <li data-id="element-5492">• Dance</li>
                    <li data-id="element-5493">• Aerobics</li>
                    <li data-id="element-5494">• Yoga</li>
                    <li data-id="element-5495">• Board games</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="order-1 md:order-2 relative" data-id="element-5496">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8v7HegjxEmi2KSxNec1Zxz/WhatsApp_Image_2025-10-24_at_10.01.25.jpg" alt="School sports team" className="w-full h-96 object-cover rounded-lg shadow-md" data-id="element-5497" />
              <div className="absolute bottom-4 right-4 bg-blue-900 text-white p-3 rounded-lg shadow-lg transform rotate-3" data-id="element-5498">
                <p className="font-bold" data-id="element-5499">IGS Sports Team</p>
                <p className="text-sm" data-id="element-5500">Ready for Competition</p>
              </div>
            </div>
          </div>
          <div className="mb-12" data-id="element-5501">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-5502">
              <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-5503">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8v7HegjxEmi2KSxNec1Zxz/WhatsApp_Image_2025-10-24_at_10.01.25.jpg" alt="Football team" className="w-full h-64 object-cover" data-id="element-5504" />
                <div className="p-6" data-id="element-5505">
                  <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-5506">
                    Football Team
                  </h3>
                  <p className="text-gray-700" data-id="element-5507">
                    Our football team has consistently excelled in inter-school
                    competitions, winning the state championship in 2022 and
                    reaching the finals multiple times.
                  </p>
                </div>
              </div>
              <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-5508">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9KTZ7HUP1wb7ieQ2CeaS6b/WhatsApp_Image_2025-10-24_at_10.01.18_%281%29.jpg" alt="Athletics team" className="w-full h-64 object-cover" data-id="element-5509" />
                <div className="p-6" data-id="element-5510">
                  <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-5511">
                    Athletics Team
                  </h3>
                  <p className="text-gray-700" data-id="element-5512">
                    Our athletics team represents the school with pride in track
                    and field events, consistently bringing home medals from
                    regional and national competitions.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Girls Sports Section */}
          <div className="mb-12 bg-gray-50 p-8 rounded-lg" data-id="element-5513">
            <div className="text-center mb-8" data-id="element-5514">
              <h3 className="text-2xl font-bold text-blue-900 mb-3" data-id="element-5515">
                Girls in Sports
              </h3>
              <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-5516"></div>
              <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-5517">
                We actively encourage and support female students in sports,
                providing equal opportunities and dedicated coaching
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-5518">
              <div data-id="element-5519">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/f2xgFc9rK22wZyJ7XvkYdc/WhatsApp_Image_2025-10-24_at_10.01.18.jpg" alt="IGS Girls Cricket Team" className="w-full rounded-lg shadow-lg" data-id="element-5520" />
              </div>
              <div data-id="element-5521">
                <h4 className="text-xl font-bold text-blue-900 mb-4" data-id="element-5522">
                  Girls Cricket Team
                </h4>
                <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-5523">
                  Our girls cricket team has made remarkable progress under the
                  guidance of dedicated coaches. The team participates in
                  inter-school competitions and has shown exceptional skill and
                  sportsmanship.
                </p>
                <p className="text-gray-700 leading-relaxed" data-id="element-5524">
                  We provide specialized training and equipment for female
                  athletes, ensuring they have every opportunity to excel in
                  their chosen sports. Our commitment to gender equality in
                  sports has resulted in outstanding performances by our female
                  students.
                </p>
              </div>
            </div>
          </div>
          {/* Football Training Section */}
          <div className="mb-12" data-id="element-5525">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-5526">
              <div className="order-2 md:order-1" data-id="element-5527">
                <h4 className="text-xl font-bold text-blue-900 mb-4" data-id="element-5528">
                  Regular Training Sessions
                </h4>
                <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-5529">
                  Our sports program includes regular training sessions on our
                  well-maintained sports fields. Students receive professional
                  coaching that focuses on skill development, teamwork, and
                  physical fitness.
                </p>
                <p className="text-gray-700 leading-relaxed" data-id="element-5530">
                  Training sessions are scheduled throughout the week, allowing
                  students to balance their academic commitments with their
                  passion for sports. Our coaches work individually with
                  students to help them reach their full potential.
                </p>
              </div>
              <div className="order-1 md:order-2" data-id="element-5531">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fqznuuu78HmKmW8bRuWFw1/WhatsApp_Image_2025-10-24_at_10.01.19.jpg" alt="Students during football training" className="w-full rounded-lg shadow-lg" data-id="element-5532" />
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-5533">
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-5534">
              <div className="flex items-center mb-4" data-id="element-5535">
                <div className="p-3 bg-blue-100 rounded-full mr-3" data-id="element-5536">
                  <AwardIcon className="h-6 w-6 text-blue-700" data-id="element-5537" />
                </div>
                <h3 className="text-xl font-bold text-blue-900" data-id="element-5538">
                  Sports Achievements
                </h3>
              </div>
              <ul className="space-y-3 text-gray-700" data-id="element-5539">
                <li className="flex items-start" data-id="element-5540">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-500 mr-2" data-id="element-5541">
                    ✓
                  </div>
                  <p data-id="element-5542">State Champions in Inter-School Football (2022)</p>
                </li>
                <li className="flex items-start" data-id="element-5543">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-500 mr-2" data-id="element-5544">
                    ✓
                  </div>
                  <p data-id="element-5545">
                    2nd Place in National School Athletics Championship (2023)
                  </p>
                </li>
                <li className="flex items-start" data-id="element-5546">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-500 mr-2" data-id="element-5547">
                    ✓
                  </div>
                  <p data-id="element-5548">Regional Table Tennis Champions (2022)</p>
                </li>
                <li className="flex items-start" data-id="element-5549">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-500 mr-2" data-id="element-5550">
                    ✓
                  </div>
                  <p data-id="element-5551">State Chess Competition Winners (2023)</p>
                </li>
              </ul>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-5552">
              <div className="flex items-center mb-4" data-id="element-5553">
                <div className="p-3 bg-blue-100 rounded-full mr-3" data-id="element-5554">
                  <BookOpenIcon className="h-6 w-6 text-blue-700" data-id="element-5555" />
                </div>
                <h3 className="text-xl font-bold text-blue-900" data-id="element-5556">
                  Sports Facilities
                </h3>
              </div>
              <ul className="space-y-3 text-gray-700" data-id="element-5557">
                <li className="flex items-start" data-id="element-5558">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-500 mr-2" data-id="element-5559">
                    ✓
                  </div>
                  <p data-id="element-5560">Standard football field with running track</p>
                </li>
                <li className="flex items-start" data-id="element-5561">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-500 mr-2" data-id="element-5562">
                    ✓
                  </div>
                  <p data-id="element-5563">Basketball and volleyball courts</p>
                </li>
                <li className="flex items-start" data-id="element-5564">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-500 mr-2" data-id="element-5565">
                    ✓
                  </div>
                  <p data-id="element-5566">Indoor sports hall for table tennis and badminton</p>
                </li>
                <li className="flex items-start" data-id="element-5567">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-500 mr-2" data-id="element-5568">
                    ✓
                  </div>
                  <p data-id="element-5569">Swimming pool (25m, 6 lanes)</p>
                </li>
              </ul>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-5570">
              <div className="flex items-center mb-4" data-id="element-5571">
                <div className="p-3 bg-blue-100 rounded-full mr-3" data-id="element-5572">
                  <CalendarIcon className="h-6 w-6 text-blue-700" data-id="element-5573" />
                </div>
                <h3 className="text-xl font-bold text-blue-900" data-id="element-5574">
                  Annual Sports Events
                </h3>
              </div>
              <ul className="space-y-3 text-gray-700" data-id="element-5575">
                <li className="flex items-start" data-id="element-5576">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-500 mr-2" data-id="element-5577">
                    ✓
                  </div>
                  <p data-id="element-5578">Inter-House Sports Competition (November)</p>
                </li>
                <li className="flex items-start" data-id="element-5579">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-500 mr-2" data-id="element-5580">
                    ✓
                  </div>
                  <p data-id="element-5581">Founders' Day Sports Festival (February)</p>
                </li>
                <li className="flex items-start" data-id="element-5582">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-500 mr-2" data-id="element-5583">
                    ✓
                  </div>
                  <p data-id="element-5584">Swimming Gala (March)</p>
                </li>
                <li className="flex items-start" data-id="element-5585">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-500 mr-2" data-id="element-5586">
                    ✓
                  </div>
                  <p data-id="element-5587">Staff vs. Students Friendly Matches (End of Term)</p>
                </li>
              </ul>
            </div>
          </div>
        </section>
        {/* Events & Activities Section */}
        <section className="mb-16" id="events" data-id="element-5588">
          <div className="text-center mb-10" data-id="element-5589">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-5590">
              Events & Activities
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-5591"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-5592">
              Our calendar is filled with academic, cultural, and social events
              that enrich the student experience and create lasting memories.
            </p>
          </div>
          <Tabs tabs={[{
          id: 'upcoming',
          label: 'Upcoming Events',
          content: <div className="py-6" data-id="element-5594">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5595">
                      {upcomingEvents.map((event, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-5596">
                          <div className="flex" data-id="element-5597">
                            <div className="mr-4" data-id="element-5598">
                              <div className="bg-blue-100 text-blue-900 font-bold rounded p-3 text-center min-w-[70px]" data-id="element-5599">
                                <div className="text-lg" data-id="element-5600">
                                  {event.date.split(',')[0].split(' ')[1]}
                                </div>
                                <div className="text-xs" data-id="element-5601">
                                  {event.date.split(',')[0].split(' ')[0].substring(0, 3).toUpperCase()}
                                </div>
                              </div>
                            </div>
                            <div data-id="element-5602">
                              <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-5603">
                                {event.name}
                              </h3>
                              <div className="flex items-center text-gray-600 mb-2" data-id="element-5604">
                                <ClockIcon className="h-4 w-4 mr-1" data-id="element-5605" />
                                <span className="text-sm" data-id="element-5606">{event.time}</span>
                                <span className="mx-2" data-id="element-5607">•</span>
                                <MapPinIcon className="h-4 w-4 mr-1" data-id="element-5608" />
                                <span className="text-sm" data-id="element-5609">
                                  {event.location}
                                </span>
                              </div>
                              <p className="text-gray-700" data-id="element-5610">
                                {event.description}
                              </p>
                            </div>
                          </div>
                        </div>)}
                    </div>
                    <div className="mt-8 text-center" data-id="element-5611">
                      <Button href="/events" variant="outline" icon={<ArrowRightIcon data-id="element-5613" />} iconPosition="right" data-id="element-5612">
                        View Full Events Calendar
                      </Button>
                    </div>
                  </div>
        }, {
          id: 'annual',
          label: 'Annual Traditions',
          content: <div className="py-6" data-id="element-5614">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-5615">
                      <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-5616">
                        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8M2i6Lt61u8AiKMZqhL6Xz/WhatsApp_Image_2025-10-24_at_10.01.22.jpg" alt="Cultural Day" className="w-full h-48 object-cover rounded-md mb-4" data-id="element-5617" />
                        <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-5618">
                          Cultural Day
                        </h3>
                        <p className="text-gray-700 mb-3" data-id="element-5619">
                          A colorful celebration of Nigeria's diverse cultures
                          featuring traditional dances, attire, and cuisine.
                          Students showcase their heritage and learn about other
                          cultures.
                        </p>
                        <div className="text-sm text-gray-600" data-id="element-5620">
                          <span className="font-medium" data-id="element-5621">When:</span> First week
                          of December
                        </div>
                      </div>
                      <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-5622">
                        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3DHAcubmTqmT13YpTTNQmr/WhatsApp_Image_2025-10-24_at_10.01.24.jpg" alt="Founders Day" className="w-full h-48 object-cover rounded-md mb-4" data-id="element-5623" />
                        <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-5624">
                          Founders' Day
                        </h3>
                        <p className="text-gray-700 mb-3" data-id="element-5625">
                          An annual commemoration of our school's founding,
                          featuring special assemblies, alumni visits, awards
                          ceremonies, and various competitions.
                        </p>
                        <div className="text-sm text-gray-600" data-id="element-5626">
                          <span className="font-medium" data-id="element-5627">When:</span> February
                          15th
                        </div>
                      </div>
                      <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-5628">
                        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5gKYWryVTvwM3jPw4Bpnok/WhatsApp_Image_2025-10-24_at_10.01.16.jpg" alt="Science Fair" className="w-full h-48 object-cover rounded-md mb-4" data-id="element-5629" />
                        <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-5630">
                          Science & Technology Fair
                        </h3>
                        <p className="text-gray-700 mb-3" data-id="element-5631">
                          Students showcase their innovative projects and
                          experiments in science, technology, engineering, and
                          mathematics. External judges evaluate the projects and
                          award prizes.
                        </p>
                        <div className="text-sm text-gray-600" data-id="element-5632">
                          <span className="font-medium" data-id="element-5633">When:</span> Second week
                          of February
                        </div>
                      </div>
                      <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-5634">
                        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bZLbes2hxk7MhXzaZ1hXLV/WhatsApp_Image_2025-10-24_at_10.01.19.jpg" alt="Inter-House Sports" className="w-full h-48 object-cover rounded-md mb-4" data-id="element-5635" />
                        <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-5636">
                          Inter-House Sports Competition
                        </h3>
                        <p className="text-gray-700 mb-3" data-id="element-5637">
                          A major highlight of the school calendar, featuring
                          track and field events, team sports, and individual
                          competitions. Houses compete for the coveted Champions
                          Trophy.
                        </p>
                        <div className="text-sm text-gray-600" data-id="element-5638">
                          <span className="font-medium" data-id="element-5639">When:</span> Second week
                          of November
                        </div>
                      </div>
                      <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-5640">
                        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jdfoyTCXLviMyjmi5MDX1X/WhatsApp_Image_2025-10-24_at_11.30.13.jpg" alt="Speech Day" className="w-full h-48 object-cover rounded-md mb-4" data-id="element-5641" />
                        <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-5642">
                          Speech & Prize-Giving Day
                        </h3>
                        <p className="text-gray-700 mb-3" data-id="element-5643">
                          An occasion to celebrate academic excellence and other
                          achievements. Awards are presented to outstanding
                          students, and graduating students receive their
                          certificates.
                        </p>
                        <div className="text-sm text-gray-600" data-id="element-5644">
                          <span className="font-medium" data-id="element-5645">When:</span> Last week
                          of the academic year
                        </div>
                      </div>
                      <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-5646">
                        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4bkQakMXE7oCJhU6DHfZ4v/WhatsApp_Image_2025-10-24_at_10.01.16_%281%29.jpg" alt="Career Day" className="w-full h-48 object-cover rounded-md mb-4" data-id="element-5647" />
                        <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-5648">
                          Career Exploration Day
                        </h3>
                        <p className="text-gray-700 mb-3" data-id="element-5649">
                          Professionals from various fields visit the school to
                          share insights about their careers. Students get to
                          ask questions and learn about different career paths.
                        </p>
                        <div className="text-sm text-gray-600" data-id="element-5650">
                          <span className="font-medium" data-id="element-5651">When:</span> First week
                          of May
                        </div>
                      </div>
                    </div>
                  </div>
        }, {
          id: 'clubs',
          label: 'Clubs & Societies',
          content: <div className="py-6" data-id="element-5652">
                    <p className="text-gray-700 mb-6" data-id="element-5653">
                      Our clubs and societies provide platforms for students to
                      explore their interests, develop skills, and build
                      relationships outside the classroom. Each club is
                      supervised by a staff advisor who provides guidance and
                      support.
                    </p>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-5654">
                      <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-5655">
                        <div className="flex items-center mb-4" data-id="element-5656">
                          <div className="p-3 bg-blue-100 rounded-full mr-3" data-id="element-5657">
                            <CpuIcon className="h-6 w-6 text-blue-700" data-id="element-5658" />
                          </div>
                          <h3 className="text-lg font-bold text-blue-900" data-id="element-5659">
                            Science & Technology Club
                          </h3>
                        </div>
                        <p className="text-gray-700 mb-3" data-id="element-5660">
                          For students passionate about science and technology.
                          Activities include experiments, robotics, coding, and
                          preparation for science competitions.
                        </p>
                        <div className="text-sm text-gray-600" data-id="element-5661">
                          <span className="font-medium" data-id="element-5662">Meeting Day:</span>{' '}
                          Tuesdays
                        </div>
                      </div>
                      <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-5663">
                        <div className="flex items-center mb-4" data-id="element-5664">
                          <div className="p-3 bg-blue-100 rounded-full mr-3" data-id="element-5665">
                            <MessageSquareIcon className="h-6 w-6 text-blue-700" data-id="element-5666" />
                          </div>
                          <h3 className="text-lg font-bold text-blue-900" data-id="element-5667">
                            Literary & Debating Society
                          </h3>
                        </div>
                        <p className="text-gray-700 mb-3" data-id="element-5668">
                          Focuses on developing public speaking, critical
                          thinking, and argumentation skills. Members
                          participate in debates, public speaking contests, and
                          model UN conferences.
                        </p>
                        <div className="text-sm text-gray-600" data-id="element-5669">
                          <span className="font-medium" data-id="element-5670">Meeting Day:</span>{' '}
                          Wednesdays
                        </div>
                      </div>
                      <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-5671">
                        <div className="flex items-center mb-4" data-id="element-5672">
                          <div className="p-3 bg-blue-100 rounded-full mr-3" data-id="element-5673">
                            <PaletteIcon className="h-6 w-6 text-blue-700" data-id="element-5674" />
                          </div>
                          <h3 className="text-lg font-bold text-blue-900" data-id="element-5675">
                            Art & Photography Club
                          </h3>
                        </div>
                        <p className="text-gray-700 mb-3" data-id="element-5676">
                          For creative students interested in visual arts.
                          Activities include drawing, painting, sculpture,
                          photography, and organizing art exhibitions.
                        </p>
                        <div className="text-sm text-gray-600" data-id="element-5677">
                          <span className="font-medium" data-id="element-5678">Meeting Day:</span>{' '}
                          Thursdays
                        </div>
                      </div>
                      <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-5679">
                        <div className="flex items-center mb-4" data-id="element-5680">
                          <div className="p-3 bg-blue-100 rounded-full mr-3" data-id="element-5681">
                            <MusicIcon className="h-6 w-6 text-blue-700" data-id="element-5682" />
                          </div>
                          <h3 className="text-lg font-bold text-blue-900" data-id="element-5683">
                            Music & Drama Club
                          </h3>
                        </div>
                        <p className="text-gray-700 mb-3" data-id="element-5684">
                          For students interested in performing arts. Members
                          learn to play instruments, sing, act, and participate
                          in school productions and competitions.
                        </p>
                        <div className="text-sm text-gray-600" data-id="element-5685">
                          <span className="font-medium" data-id="element-5686">Meeting Day:</span>{' '}
                          Fridays
                        </div>
                      </div>
                      <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-5687">
                        <div className="flex items-center mb-4" data-id="element-5688">
                          <div className="p-3 bg-blue-100 rounded-full mr-3" data-id="element-5689">
                            <GlobeIcon className="h-6 w-6 text-blue-700" data-id="element-5690" />
                          </div>
                          <h3 className="text-lg font-bold text-blue-900" data-id="element-5691">
                            Environmental Club
                          </h3>
                        </div>
                        <p className="text-gray-700 mb-3" data-id="element-5692">
                          Focuses on environmental conservation and
                          sustainability. Activities include tree planting,
                          recycling initiatives, and awareness campaigns.
                        </p>
                        <div className="text-sm text-gray-600" data-id="element-5693">
                          <span className="font-medium" data-id="element-5694">Meeting Day:</span>{' '}
                          Mondays
                        </div>
                      </div>
                      <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-5695">
                        <div className="flex items-center mb-4" data-id="element-5696">
                          <div className="p-3 bg-blue-100 rounded-full mr-3" data-id="element-5697">
                            <CpuIcon className="h-6 w-6 text-blue-700" data-id="element-5698" />
                          </div>
                          <h3 className="text-lg font-bold text-blue-900" data-id="element-5699">
                            Robotics Club
                          </h3>
                        </div>
                        <p className="text-gray-700 mb-3" data-id="element-5700">
                          For students interested in robotics and engineering.
                          Members learn to design, build, and program robots,
                          and participate in robotics competitions.
                        </p>
                        <div className="text-sm text-gray-600" data-id="element-5701">
                          <span className="font-medium" data-id="element-5702">Meeting Day:</span>{' '}
                          Tuesdays
                        </div>
                      </div>
                    </div>
                    <div className="mt-8 text-center" data-id="element-5703">
                      <Button href="/student-life/clubs" variant="outline" icon={<ArrowRightIcon data-id="element-5705" />} iconPosition="right" data-id="element-5704">
                        Explore All Clubs & Societies
                      </Button>
                    </div>
                  </div>
        }]} variant="pills" className="mb-8" data-id="element-5593" />
        </section>
        {/* Testimonials Section */}
        <section id="testimonials" data-id="element-5706">
          <div className="text-center mb-10" data-id="element-5707">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-5708">
              Student & Parent Testimonials
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-5709"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-5710">
              Hear from our students and parents about their experiences at
              Isonyin Grammar School.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-5711">
            {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-8 rounded-lg shadow-md relative" data-id="element-5712">
                <div className="absolute -top-4 -left-4 text-6xl text-yellow-500 opacity-30" data-id="element-5713">
                  "
                </div>
                <div className="relative z-10" data-id="element-5714">
                  <p className="text-gray-700 italic mb-6 leading-relaxed" data-id="element-5715">
                    {testimonial.quote}
                  </p>
                  <div className="flex items-center" data-id="element-5716">
                    <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-5717" />
                    <div data-id="element-5718">
                      <h4 className="font-bold text-blue-900" data-id="element-5719">
                        {testimonial.name}
                      </h4>
                      <p className="text-sm text-gray-500" data-id="element-5720">
                        {testimonial.role}
                      </p>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
          <div className="mt-12 bg-blue-900 text-white p-8 rounded-lg text-center" data-id="element-5721">
            <h3 className="text-2xl font-bold mb-4" data-id="element-5722">
              Experience Isonyin Grammar School
            </h3>
            <p className="mb-6 max-w-2xl mx-auto" data-id="element-5723">
              Join our community of learners and future leaders. Discover the
              IGS difference through our holistic approach to education that
              nurtures academic excellence, character development, and talent
              discovery.
            </p>
            <div className="flex flex-wrap justify-center gap-4" data-id="element-5724">
              <Button href="/admissions" variant="primary" size="lg" animation="scale" data-id="element-5725">
                Apply for Admission
              </Button>
              <Button href="/virtual-tour" variant="outline" size="lg" className="border-white text-white hover:bg-white/10" data-id="element-5726">
                Take a Virtual Tour
              </Button>
            </div>
          </div>
        </section>
      </div>
    </div>;
};
export default memo(StudentLife);